import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

import CardFront from '../imgs/covers/other1.jpg'
//import CardBack from '../imgs/cover4.jpg'
import CardBack from '../imgs/cover1.jpg'

const styles = theme => ({
    container: {
    },
    left_bar: {
        width: 200
    },
    content: {
        width: '100%'
    },
    img: {
        width: '100%'
    },
    title: {
        marginBottom: 30,
        color: '#393287'
    },
    p: {
        marginTop: 20,
        color: '#393287',
        fontSize: 16
    },
    p2: {
        marginTop: 0,
        marginBottom: 40,
        color: '#393287'
    },
    ul: {
        marginBlockStart: 0
    },
    details: {
        paddingLeft: 10
    }
})

class Home extends React.Component{
    render(){
        const {classes} = this.props

        return (
            <Grid container>
                <Grid item md={4} sm={12}>
                    <Typography variant="title" className={classes.p}>
                        One-Day Redesign
                    </Typography>
                    <Typography variant="subheading" className={classes.p2}>
                        One-Day Redesign works with any style house, apartment or condo. Purpleleaf Design can integrate various design styles, and show you new ways to display your favorite treasures, putting them in the best possible light. You’ll be amazed to see what we can do in just a few hours.
                    </Typography>

                    <Typography variant="title" className={classes.p}>
                        Read the scenarios below and see which one fits your situation:
                    </Typography>
                    <Typography variant="subheading" className={classes.p2}>
                        <ul className={classes.ul}>
                            <li>I’ve had the same arrangement for years and I’m ready for a new look, but I don’t want to spend a lot of money buying new things.</li>
                            <li>I’ve tried everything—rearranging the furniture, buying new things—but something is still not quite right.</li>
                            <li>We just finished remodeling and want my finished room to look its best.</li>
                            <li>My room has the basics, but needs some finishing touches.</li>
                            <li>We just moved into a new house and want to make our existing things work in our new space.</li>
                            <li>We just moved into a new house and want to make our existing things work in our new space.</li>
                            <li>We just inherited furnishings and want to incorporate them with our existing things.</li>
                        </ul>
                    </Typography>
                </Grid>
                <Grid item md={8} sm={12} className={classes.details}>
                    {/* <img src={CardFront} className={classes.img}/> */}
                    <img src={CardBack} className={classes.img}/>
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(styles)(Home)